var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithToggleAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    stroke: "#0195D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8326 22.8903C29.7999 19.353 32.8033 17.632 32.9406 17.5519C31.2397 15.134 28.6033 14.8037 27.6769 14.7773C25.4627 14.5501 23.3149 16.0691 22.1869 16.0691C21.0365 16.0691 19.2996 14.7993 17.4276 14.8366C15.0186 14.8728 12.765 16.2327 11.529 18.3443C8.97817 22.65 10.8806 28.9773 13.3244 32.4576C14.5469 34.1621 15.9754 36.0652 17.8452 35.9983C19.6744 35.9247 20.3577 34.8612 22.5652 34.8612C24.7524 34.8612 25.394 35.9983 27.3009 35.9555C29.2641 35.9247 30.5001 34.2433 31.6798 32.5235C33.0926 30.5698 33.6599 28.6459 33.6824 28.5471C33.6363 28.5317 29.8697 27.1301 29.8326 22.8903Z",
    fill: "#0195D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2304 12.4878C27.2142 11.2882 27.8874 9.65619 27.7005 8C26.2766 8.06146 24.4957 8.96035 23.4702 10.1336C22.5629 11.1675 21.7524 12.8621 21.9618 14.4557C23.5614 14.5721 25.2038 13.6688 26.2304 12.4878Z",
    fill: "#0195D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithToggleAppIcon);
export default __webpack_public_path__ + "static/media/with-toggle-app-icon.445f0023c0722d85c7f46f4609a01736.svg";
export { ForwardRef as ReactComponent };